import { EstatePage_TestamentaryEntityFragment } from '@/modules/estate/graphql/EstatePageData.generated';
import { englishJoinStringList } from '@/utils/formatting/strings';
import { getNodes } from '@/utils/graphqlUtils';

export interface SubtrustGroup {
  key: string;
  parentNames: string;
  subtrusts: EstatePage_TestamentaryEntityFragment[];
}

export function groupSubtrustsByCreatedFrom(
  subtrusts: EstatePage_TestamentaryEntityFragment[]
): {
  parentGroups: SubtrustGroup[];
  allOthers: EstatePage_TestamentaryEntityFragment[];
} {
  const groupsByParentIds = new Map<string, SubtrustGroup>();
  const allOthers: EstatePage_TestamentaryEntityFragment[] = [];

  subtrusts.forEach((subtrust) => {
    const parents = getNodes(subtrust.createdFromEntities);

    if (parents.length === 0) {
      allOthers.push(subtrust);
      return;
    }

    const parentIds = parents
      .map((parent) => parent.id)
      .sort()
      .join('|');
    const existingGroup = groupsByParentIds.get(parentIds);

    if (existingGroup) {
      existingGroup.subtrusts.push(subtrust);
      return;
    }

    groupsByParentIds.set(parentIds, {
      key: parentIds,
      parentNames: englishJoinStringList(
        parents.map((parent) => parent.subtype.displayName)
      ),
      subtrusts: [subtrust],
    });
  });

  return {
    parentGroups: Array.from(groupsByParentIds.values()),
    allOthers,
  };
}
